module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-2 content-area"
  }, [_c('grid-x', {
    attrs: {
      "col": "2fr 0.5fr",
      "rows": "1fr",
      "gap": "2em"
    }
  }, [_c('div', {
    staticClass: "col-2-1"
  }, [_c('div', {
    staticClass: "widget-buttons"
  }, [(_vm.article.status == 'draft' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishPost();
      }
    }
  }, [_vm._v("PUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.openPreviewModal();
      }
    }
  }, [_vm._v("PREVIEW")]), _vm._v(" "), (_vm.article.status == 'publish' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishPost();
      }
    }
  }, [_vm._v("UNPUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.savePostData(_vm.article)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), (_vm.articleKey) ? _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.toggleHistoryModal()
      }
    }
  }, [_vm._v("HISTORY")]) : _vm._e(), _vm._v(" "), (_vm.autosaved && _vm.article.lastAutosave) ? _c('span', [_vm._v("AUTOSAVED VERSION " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.lastAutosave.timestamp * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Article")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "title", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.article.layout == 'article-layout-evergreen' && (_vm.article.toc && _vm.article.toc.length > 0)) ? _c('div', [_c('h3', [_vm._v("Table of contents")]), _vm._v(" "), _c('ul', {
    staticClass: "toc"
  }, _vm._l((_vm.article.toc), function(item, index) {
    return _c('li', {
      key: ("item-" + index)
    }, [_c('a', {
      attrs: {
        "href": item.anchor
      }
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), (item.subContents.length > 0) ? _c('ul', _vm._l((item.subContents), function(subItem, index) {
      return _c('li', {
        key: ("subitem-" + index)
      }, [_c('a', {
        attrs: {
          "href": subItem.anchor
        }
      }, [_vm._v(_vm._s(subItem.title))])])
    })) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.article.layout == 'article-layout-evergreen' || _vm.article.layout == 'article-layout-featured') ? _c('div', {
    staticClass: "editor-area-parent"
  }, [_c('md-tabs', {
    on: {
      "md-changed": _vm.changeWidgetsTab
    }
  }, [_c('md-tab', {
    attrs: {
      "id": "contentEditor",
      "md-label": "Edit Content"
    }
  }), _vm._v(" "), _c('md-tab', {
    attrs: {
      "id": "layoutEditor",
      "md-label": "Edit Layout"
    }
  })], 1), _vm._v(" "), _c('md-content', {
    staticClass: "editor-area"
  }, [('contentEditor' == _vm.currentTab) ? _c('div', _vm._l((_vm.article.widgets), function(item, key) {
    return _c('div', {
      key: key
    }, [(item.dropcap) ? _c('div', {
      staticStyle: {
        "margin": "0 auto",
        "text-align": "center"
      }
    }, [_vm._v("DROPCAP ENABLED")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_vm._v("Widget " + _vm._s(key))]), _vm._v(" "), _c(item.type, {
      tag: "component",
      on: {
        "changeImage": function($event) {
          _vm.changeImage($event, item)
        },
        "toggle-images-modal": _vm.toggleImagesModal,
        "toggle-dropcap": function($event) {
          item.dropcap = !item.dropcap
        }
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), ('layoutEditor' == _vm.currentTab) ? _c('div', [_c('draggable', {
    staticStyle: {
      "width": "600px",
      "margin": "0 auto"
    },
    on: {
      "start": function($event) {
        _vm.drag = true
      },
      "end": function($event) {
        _vm.drag = false
      }
    },
    model: {
      value: (_vm.article.widgets),
      callback: function($$v) {
        _vm.$set(_vm.article, "widgets", $$v)
      },
      expression: "article.widgets"
    }
  }, _vm._l((_vm.article.widgets), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "draggable-items flex center-flex-y flex-space-between"
    }, [_c('div', {
      staticClass: "flex center-flex-y"
    }, [_c('svg', {
      staticClass: "draggable-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "24",
        "height": "24",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      attrs: {
        "fill": "none",
        "d": "M0 0h24v24H0V0z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(key) + " - " + _vm._s(item.type))])]), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeWidget(key)
        }
      }
    }, [_vm._v("Remove")])])
  }))], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "width": "400px",
      "margin": "0 auto",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newWidgetType),
      expression: "newWidgetType"
    }],
    attrs: {
      "placeholder": "Current Widget Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.newWidgetType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Widget Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "froala-editor"
    }
  }, [_vm._v("Text Editor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "code-editor"
    }
  }, [_vm._v("HTML Editor")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-full-width"
    }
  }, [_vm._v("Full Width Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video-full-width"
    }
  }, [_vm._v("Full Width Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "video-scroller"
    }
  }, [_vm._v("Video Scroller")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-double"
    }
  }, [_vm._v("Double Image Row")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-featured"
    }
  }, [_vm._v("Featured Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "featured-quote"
    }
  }, [_vm._v("Featured Quote")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-standard"
    }
  }, [_vm._v("Standard Image")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "image-circle"
    }
  }, [_vm._v("Circle Image")])])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "200px",
      "height": "30px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.createWidget
    }
  }, [_vm._v("New Widget")])])])], 1) : _vm._e(), _vm._v(" "), (_vm.article.layout == 'article-layout-default' || !_vm.article.layout) ? _c('div', {
    staticClass: "editor-area-parent"
  }, [_c('froala-editor', {
    on: {
      "toggle-modal": _vm.toggleImagesModal
    },
    model: {
      value: (_vm.article.content),
      callback: function($$v) {
        _vm.$set(_vm.article, "content", $$v)
      },
      expression: "article.content"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "26px"
    }
  }, [_c('div', {
    staticClass: "widget-buttons",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-17px"
    }
  }, [(_vm.article.status == 'draft' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.publishPost();
      }
    }
  }, [_vm._v("PUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.articlePreviewModalOpen = true
      }
    }
  }, [_vm._v("PREVIEW")]), _vm._v(" "), (_vm.article.status == 'publish' || _vm.article.status == 'preview') ? _c('button', {
    staticClass: "pub-buttons",
    on: {
      "click": function($event) {
        _vm.unpublishPost();
      }
    }
  }, [_vm._v("UNPUBLISH")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.savePostData(_vm.article)
      }
    }
  }, [_vm._v("UPDATE")]), _vm._v(" "), (_vm.articleKey) ? _c('button', {
    staticClass: "pub-buttons",
    staticStyle: {
      "margin-right": "10px"
    },
    on: {
      "click": function($event) {
        _vm.toggleHistoryModal()
      }
    }
  }, [_vm._v("HISTORY")]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("SEO Scorecard")]), _vm._v(" "), _c('div', {
    staticClass: "scorecard"
  }, [_c('md-list', [_c('md-subheader', [_vm._v("Metadata")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "titleContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Title Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "slugContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Slug Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoDescriptionLength"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Description 120-156 Chars")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoTitleContainsPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Title Contains Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "seoTitleStartsWithPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("SEO Title Starts With Phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "relatedTags"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Similar Phrase In Tags")])], 1)], 1), _vm._v(" "), _c('md-list', [_c('md-subheader', [_vm._v("Images")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "containsImage"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("At Least 1 Article Image")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageWithPhraseInAlt"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Image With Phrase In Alt")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageWithPhraseInCaption"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Image With Phrase In Caption")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "imageIsBelowTargetSize"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("All Images Sized Appropriately")])], 1)], 1), _vm._v(" "), _c('md-list', [_c('md-subheader', [_vm._v("Content")]), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "phraseInFirst100Words"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Phrase In First 100 Words")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "headingWithTargetPhrase"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Heading with target phrase")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "phraseMentioned4Times"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Phrase Mentioned x4")])], 1), _vm._v(" "), _c('md-list-item', [_c('md-checkbox', {
    attrs: {
      "value": "similarPhraseMentioned10Times"
    },
    model: {
      value: (_vm.scorecard),
      callback: function($$v) {
        _vm.scorecard = $$v
      },
      expression: "scorecard"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-list-item-text"
  }, [_vm._v("Similar Phrases Mentioned x10")])], 1)], 1)], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-2-2",
    staticStyle: {
      "min-width": "460px"
    }
  }, [_c('div', [_c('h3', [_vm._v("Status")]), _vm._v(" "), _c('div', [_c('div', [_vm._v("Status: " + _vm._s(_vm.article.status))]), _vm._v(" "), (_vm.article.lastUpdated) ? _c('div', [_vm._v("Last Updated: " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.lastUpdated * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e(), _vm._v(" "), (_vm.article.timestamp) ? _c('div', [_vm._v("Published: " + _vm._s(_vm._f("moment")(_vm.$moment(_vm.article.timestamp * 1000), "HH:mm DD/MM/YYYY")))]) : _vm._e()]), _vm._v(" "), _c('h3', [_vm._v("Target Phrase")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Target Phrase")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.targetPhrase),
      expression: "article.targetPhrase"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Phrase"
    },
    domProps: {
      "value": (_vm.article.targetPhrase)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "targetPhrase", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "height": "30px",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        _vm.openTrends(_vm.article.targetPhrase)
      }
    }
  }, [_vm._v("TRENDS")])]), _vm._v(" "), _c('h3', [_vm._v("Meta")]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Slug")]), _vm._v(" "), _c('div', {
    class: 'input-box slug-input ' + _vm.slugValid
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.slug),
      expression: "article.slug"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Slug"
    },
    domProps: {
      "value": (_vm.article.slug)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "slug", $event.target.value)
      }, _vm.checkSlug]
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-top": "5px",
      "padding-right": "5px"
    }
  }, [_vm._v(_vm._s(_vm.slugValid))])]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Author")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('md-autocomplete', {
    attrs: {
      "md-options": _vm.authors || []
    },
    on: {
      "md-changed": _vm.getAuthors,
      "md-opened": _vm.getAuthors
    },
    scopedSlots: _vm._u([{
      key: "md-autocomplete-empty",
      fn: function(ref) {
        var term = ref.term;

        return [_vm._v("\n                  No Authors matching \"" + _vm._s(term) + "\" were found.\n                ")]
      }
    }, {
      key: "md-autocomplete-item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticStyle: {
            "font-size": "initial"
          }
        }, [_vm._v(_vm._s(item))])]
      }
    }]),
    model: {
      value: (_vm.article.authorSlug),
      callback: function($$v) {
        _vm.$set(_vm.article, "authorSlug", $$v)
      },
      expression: "article.authorSlug"
    }
  }, [_c('label')])], 1), _vm._v(" "), (_vm.article.meta) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Social Title")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.meta['og:title']),
      expression: "article.meta['og:title']"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.article.meta['og:title'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.meta, 'og:title', $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('google-preview', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "slug": _vm.article.slug
    },
    model: {
      value: (_vm.article.meta),
      callback: function($$v) {
        _vm.$set(_vm.article, "meta", $$v)
      },
      expression: "article.meta"
    }
  }), _vm._v(" "), (_vm.showTags) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('div', {
    staticClass: "input-box tag-input-container",
    staticStyle: {
      "height": "auto"
    }
  }, [(_vm.showTags) ? _c('tag-input', {
    attrs: {
      "options": _vm.tags,
      "placeholder": "Enter tags",
      "value": _vm.article.tags,
      "multiple": true
    },
    on: {
      "value": _vm.setTags
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Category")]), _vm._v(" "), (_vm.showCategory) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.parentCategory),
      expression: "article.parentCategory"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "parentCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.updateSubcategories]
    }
  }, _vm._l((_vm.categories), function(item, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.subCategories) ? _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.subCategory),
      expression: "article.subCategory"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "subCategory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.subCategories), function(subitem, subkey) {
    return _c('option', {
      key: subkey,
      domProps: {
        "value": subitem
      }
    }, [_vm._v(_vm._s(subitem))])
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Select Layout")]), _vm._v(" "), _c('div', {
    staticClass: "input-box down-caret"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.layout),
      expression: "article.layout"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "layout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.layouts), function(layout, layoutkey) {
    return _c('option', {
      key: layoutkey,
      domProps: {
        "value": layout
      }
    }, [_vm._v(_vm._s(layout))])
  }))]), _vm._v(" "), _c('div', [_c('h3', [_vm._v("Branded Details")]), _vm._v(" "), (!_vm.article.sponsored_post_data) ? _c('div', [_c('button', {
    on: {
      "click": function($event) {
        _vm.article.sponsored_post_data = {
          brand_name: '',
          brand_image_url: ''
        }
      }
    }
  }, [_vm._v("Enable Branding")])]) : _vm._e(), _vm._v(" "), (_vm.article.sponsored_post_data) ? _c('div', [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_image_click_link),
      expression: "article.sponsored_post_data.brand_image_click_link"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Link"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_image_click_link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_image_click_link", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Brand Name")]), _vm._v(" "), _c('div', {
    staticClass: "input-box"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_name),
      expression: "article.sponsored_post_data.brand_name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Brand Name"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-label"
  }, [_vm._v("Brand Text")]), _vm._v(" "), _c('div', {
    staticClass: "input-box",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.sponsored_post_data.brand_text),
      expression: "article.sponsored_post_data.brand_text"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Brand Text"
    },
    domProps: {
      "value": (_vm.article.sponsored_post_data.brand_text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.sponsored_post_data, "brand_text", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.article.sponsored_post_data.brand_image_url) ? _c('img', {
    attrs: {
      "src": _vm.article.sponsored_post_data.brand_image_url
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'branded'
        })
      }
    }
  }, [_vm._v("Change Image")])]), _vm._v(" "), _c('button', {
    staticStyle: {
      "margin-top": "10px"
    },
    on: {
      "click": function($event) {
        _vm.article.sponsored_post_data = false
      }
    }
  }, [_vm._v("Remove Branding")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "images"
  }, [_c('div', {
    staticClass: "featured-images"
  }, [_c('h3', [_vm._v("Featured Image")]), _vm._v(" "), (_vm.article.image && _vm.article.image.desktop) ? _c('div', {}, [_c('div', [_vm._v("Desktop")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.article.image.desktop
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.article.image && _vm.article.image.mobile) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_vm._v("Mobile")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.article.image.mobile
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'preview-' + _vm.article.layout
        })
      }
    }
  }, [_vm._v("Change Image")])])]), _vm._v(" "), _c('div', {
    staticClass: "social-images"
  }, [_c('h3', [_vm._v("Social Image")]), _vm._v(" "), (_vm.article.socialImage) ? _c('img', {
    attrs: {
      "src": _vm.article.socialImage
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.toggleImagesModal({
          type: 'social'
        })
      }
    }
  }, [_vm._v("Change Image")])])])])], 1)])]), _vm._v(" "), (_vm.historyModalOpen) ? _c('modal-history', {
    ref: "modalhistory",
    attrs: {
      "id": _vm.articleKey
    },
    on: {
      "restore": _vm.replaceArticle,
      "close": function($event) {
        _vm.historyModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.articlePreviewModalOpen) ? _c('modal-article-preview', {
    ref: "modalarticlepreview",
    attrs: {
      "slug": _vm.article['slug'],
      "password": _vm.article['password']
    },
    on: {
      "close": function($event) {
        _vm.articlePreviewModalOpen = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('modal-image-workflow', {
    ref: "imageWorkflow"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-664a782c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/articleEditor.vue
// module id = 666
// module chunks = 1